import { useSelector } from 'react-redux';

import authrium_logo from '../images/authrium_logo.png';
import translations from '../data/translation';
import { Config } from '../common/config';

export default function Footer() {
  const language = useSelector(state => state?.language?.language) || 'ko';
  const t = translations[language];

  return (
    <>
      <footer>
        <section className="footer_box">
          <div className="footer_001">
            <img src={authrium_logo} alt="Authrium" />
            <div
              style={{
                fontSize: '12px',
                lineHeight: '18px',
                color: '#777',
                marginTop: '16px',
                marginBottom: '16px',
              }}
            >
              <div style={{ whiteSpace: 'nowrap' }}>
                <span style={{ marginRight: '10px' }}>
                  {t.bizNumLabel} : 849-85-02924 | {t.representativeLabel} :{' '}
                  {t.defaultRepresentative}
                </span>
              </div>
              <div style={{ whiteSpace: 'nowrap' }}>
                <span style={{ marginRight: '10px' }}>
                  {t.storeNameLabel} : {t.defaultStoreName}
                </span>
                <span style={{ margin: '0 10px', color: '#ccc' }}>|</span>
                <span>
                  {t.phoneLabel} : {t.defaultPhone}
                </span>
              </div>
              <div style={{ whiteSpace: 'nowrap' }}>
                <span style={{ marginRight: '10px' }}>
                  {t.addressLabel} : {t.defaultAddress}
                </span>
              </div>
              <div>
                {t.operationHoursLabel}: {t.defaultOperationHours}
              </div>
              <div>{t.defaultOperationHoursNote}</div>
            </div>
          </div>
          <div className="footer_002">
            <ul className="footer_003">
              <li>
                {/* [2026-10-30 X-03] 환경별 메인 사이트 주소(dev=www-dev) — www-qa 고정 링크였음 */}
                <a href={`${Config.SHOPMAIN_SERVER}user-agreement`}>
                  {t.serviceTerms}
                </a>
              </li>
              <li>
                <a href={`${Config.SHOPMAIN_SERVER}user-privacy`}>
                  {t.privacyPolicy}
                </a>
              </li>
            </ul>
            <div className="footer_004">
              <a
                href="mailto:naegift@naver.com"
                style={{
                  display: 'inline-block',
                  marginTop: '6px',
                  fontSize: '14px',
                  lineHeight: '22px',
                  color: '#555',
                }}
              >
                naegift@naver.com
              </a>
              <p
                style={{
                  marginTop: '2px',
                  fontSize: '15px',
                  lineHeight: '22px',
                  color: '#555',
                  fontFamily:
                    "'Noto Sans KR', 'Apple SD Gothic Neo', 'Malgun Gothic', 'Nanum Gothic', sans-serif",
                }}
              >
                {t.poweredBy}
              </p>
            </div>
          </div>
        </section>
      </footer>
    </>
  );
}
